import type { QueryClient } from "@tanstack/react-query";
import { normalizeId } from "utils";
import { scheduleKeys } from "./schedule.keys";

export interface InvalidateScheduleQueriesOptions {
  /** When false, stripboard cache is left intact (e.g. after a successful daybreak PATCH merge). */
  includeStripboard?: boolean;
}

export const invalidateScheduleQueries = async (
  queryClient: QueryClient,
  projectId: string | number,
  documentId: string | number,
  options?: InvalidateScheduleQueriesOptions
): Promise<void> => {
  const pid = normalizeId(projectId);
  const did = normalizeId(documentId);
  const includeStripboard = options?.includeStripboard !== false;

  const invalidations = [
    queryClient.invalidateQueries({ queryKey: scheduleKeys.boneyard(pid, did) }),
    queryClient.invalidateQueries({ queryKey: scheduleKeys.dayOutOfDays(pid, did) }),
  ];
  if (includeStripboard) {
    invalidations.push(
      queryClient.invalidateQueries({ queryKey: scheduleKeys.stripboard(pid, did) })
    );
  }
  await Promise.all(invalidations);
};
